import React from 'react';

import { TabComponent, TabsContainer } from "./SectionTabs.styles";
import {
    TokenIcon,
    TokensButton
} from '../JobBoard/JobBoard.styles';

interface SectionTabsProps {
    tabs: {
        onClick: () => void,
        isActive: boolean,
        label: string
    }[],
    className?: string,
    tokensCount?: number,
    onTokensClick?: () => void
}

const SectionTabs = ({ tabs, className, tokensCount, onTokensClick }: SectionTabsProps) => {
    return (
        <TabsContainer className={className}>
            {tabs.map(({onClick, isActive, label}) => (
                <TabComponent
                    key={label}
                    className='no-fastclick'
                    onClick={onClick}
                    $isActive={isActive}
                >
                    {label}
                </TabComponent>
            ))}
            {tokensCount!==undefined && (
            <TokensButton onClick={onTokensClick}>
                <TokenIcon />
                <span>{tokensCount}</span>
                </TokensButton>
            )}
        </TabsContainer>
    )
}

export default SectionTabs;
